import {Injectable} from '@angular/core';

@Injectable()
export class HeaderService {
  isSidebarFlag = true;
  isTaskbarFlag = true;
  isUsernameFlag = true;

  constructor() {
  }

  showSideMenu() {
    this.isSidebarFlag = true;
  }

  showTaskMenu() {
    this.isTaskbarFlag = true;
  }

  hideSideMenu() {
    this.isSidebarFlag = false;
  }

  hideTaskMenu() {
    this.isTaskbarFlag = false;
  }

  showUsername() {
    this.isUsernameFlag = true;
  }

  hideUsername() {
    this.isUsernameFlag = false;
  }


}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/header.service.ts